import { Component, OnInit,Pipe, PipeTransform } from '@angular/core';
import { RegisterService } from '../service/register.service';
import { AccountForm } from '../model/rest/AccountForm';
import { NgModel } from '@angular/forms';
import { Routes,RouterModule} from '@angular/router';



@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  
  accountForm : AccountForm = new AccountForm();
  submitted = false;

  constructor(private registerService : RegisterService){}
 
  ngOnInit() {
   /* this.accountForm = {
      firstname : "naruto",
      lastname : "sasuke",
      email : "sasuke03@gmail.com",
      password: "password1234567",
      birthdate: "1976-12-11",
      phoneNumber : "123456780",
      accountType : "SELLER"
    };*/
  }

  private save() {
  
    console.log('AccountForm ', this.accountForm);


    this.registerService.createAccount(this.accountForm).subscribe(data =>console.log(data),error => console.log(error));

  }
  
  
  onSubmit() {
    this.submitted = true;
    this.save();
  }
 

}
